module.exports = {
	"root": "findify-components--banner",
	"image": "findify-components--banner__image"
};